export default function Footer() {
  return (
    <footer className="border-t border-[var(--border-subtle)] mt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div>
          <div className="font-display text-xl tracking-widest">GET RIGHT CONSULTANT</div>
          <div className="text-xs text-[var(--text-muted)] uppercase tracking-widest">by Dev Da Don · Elevate every detail</div>
        </div>
        <div className="text-xs font-mono text-[var(--text-muted)]">
          © {new Date().getFullYear()} Get Right Consultant. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
